import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../../common/selectCustom'
import { changeSettingTable, selectDataTable } from '../store/slice'

export const ConditionCell = ({ rowId, isDefaultProfile }) => {
  const dispatch = useDispatch()

  const dataRow = useSelector(selectDataTable(rowId))
  const disabled =
    isDefaultProfile || !dataRow.sendNotification || dataRow.disabled

  const onChangeType = (value) => {
    dispatch(
      changeSettingTable({
        id: rowId,
        value: {
          ...dataRow,
          conditions: [
            {
              conditionId: value.conditionId,
            },
          ],
        },
      }),
    )
  }
  useEffect(() => {
    if (!dataRow?.conditions?.[0]?.conditionId) {
      onChangeType({
        conditionId: dataRow.conditionSettings[0].conditionId,
      })
    }
  }, [dataRow])

  return (
    <div className="dFlex">
      <SelectCustom
        activeItem={{ value: dataRow?.conditions?.[0]?.conditionId }}
        data={dataRow.conditionSettings.map((item) => ({
          ...item,
          label: item.conditionName,
          value: item.conditionId,
        }))}
        chooseItem={onChangeType}
        disabled={disabled}
        isI18n
        zIndex={14}
        style={{
          backgroundColor: '#D5D5D5',
          color: disabled ? '#9C9C9C' : '#3A414B',
          cursor: disabled ? 'not-allowed' : 'pointer',
          padding: '0px 27px 0px 12px',
          width: '100%',
          minWidth: 80,
          maxWidth: 165,
        }}
        styleDropdown={{ whiteSpace: 'nowrap' }}
      />
    </div>
  )
}
